export class PaymentPlanDetail {
    public TotalLoan: number | null;

    constructor(TotalLoan: number) {
        this.TotalLoan = TotalLoan;
    }
}
